export const CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING =
  "CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING"
export const CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS =
  "CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS"
export const CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED =
  "CO_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED"
